import { render } from "./boardTerms.vue?vue&type=template&id=47e1d1b1&scoped=true&ts=true"
import script from "./boardTerms.vue?vue&type=script&lang=ts"
export * from "./boardTerms.vue?vue&type=script&lang=ts"

import "./boardTerms.vue?vue&type=style&index=0&id=47e1d1b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e1d1b1"]])

export default __exports__